// Launch scope: email/document import only. No image types, so the iOS
// WebView picker offers Files only (no Take Photo / Take Video).
export const EMAIL_DOCUMENT_ACCEPT = ".eml,.pdf,.txt,.html";
